import React from 'react';
import { useNavigate, useParams } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import {
  CustomStars,
  CustomStarsRadioField,
} from '../../../components/FormCom/CustomStarsRadioField';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextAreaInputField } from '../../../components/FormCom/FormField';
import useRating from '../../../hooks/dashboard/rating/useRating';
import {
  RatingDataType,
  RatingInitialValues,
  RatingSchema,
} from '../../../models/dashboard/rating/rating';
import { RATING_SUCCESS } from '../../../routes/routeConstants';

const Rating = () => {
  const { submitRating, loading } = useRating();
  const { tripId } = useParams();
  const navigate = useNavigate();

  const onSubmit = (values: RatingDataType, actions: any) => {
    submitRating({ ...values, tripId }, () => {
      actions.resetForm();
      navigate(`/${RATING_SUCCESS}`);
    });
  };

  return (
    <Container>
      <FormComponent
        initialValues={RatingInitialValues}
        schema={RatingSchema}
        onSubmit={onSubmit}
        className='fit'
      >
        <ContentArea>
          <Header>
            <HeaderText>Customer feedback</HeaderText>
            <DescriptionText>
              Please provide feedback about your recent experience.
            </DescriptionText>
          </Header>

          <BodySection>
            <BoldText>
              Rate your satisfaction of your delivery experience with our driver
            </BoldText>
            <StarArea>
              <CustomStarsRadioField name='rating' className='slim-error'>
                <CustomStars name='rating' />
              </CustomStarsRadioField>
            </StarArea>
            <TextAreaInputField
              name='comments'
              id='comments'
              type='text'
              label='Enter comments'
              placeholder={`Please provide feedback about your recent experience.`}
            />
          </BodySection>

          <FormSubmitButton className='with-375 full-mobile' loading={loading}>
            Submit
          </FormSubmitButton>
        </ContentArea>
      </FormComponent>
    </Container>
  );
};

export default Rating;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background-color: ${({ theme }) => theme.palette.blueGrayBg};
`;

const ContentArea = styled.div`
  width: 555px;
  margin-top: 64px;

  @media (max-width: 884px) {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 24px;
  padding: 20px;
  margin-bottom: 20px;
  gap: 8px;
`;

const HeaderText = styled.div`
  font-size: 34px;
  line-height: 34px;
  font-weight: 500;
  margin-bottom: 8px;

  @media (max-width: 884px) {
    font-size: 24px;
  }
`;

const DescriptionText = styled.div`
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
`;

const BodySection = styled.div`
  padding: 12px 24px;
  font-weight: 600;
  border: 1px solid #e0e0e0e0;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.blueGrayBg};
  display: flex;
  gap: 12px;
  flex-direction: column;
  /* justify-content: center;
  align-items: center; */
  margin-bottom: 100px;
`;

const BoldText = styled.div`
  font-weight: 600;
  font-size: 14px;
`;

const StarArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 52px;
  background-color: #fff;
`;
